<template>
    <div class="p-3 row">
        <input-text class="col-12 col-md-3" :disabled="readonly" type="number" label="Código interno"  :max-length="4" v-model="form.codigoInterno" ref="codigoInterno" required/>
        <input-text class="col-12 col-md-3" :disabled="readonly" type="number" label="Ano" :min="1900" :max-length="4" v-model="form.ano" ref="ano" required/>
        <input-text class="col-12 col-md-3" :disabled="readonly" label="Versão" ref="versao" v-model="form.versao" required/>
        <input-select class="col-12 col-md-3" :disabled="readonly" :options="options.simnao" label="Avaliação inicial" ref="avaliacao" v-model="form.avaliacaoInicial" required/>
        <div class="col-12" v-if="!readonly">
            <b-button v-if="permissao.c" variant="success" @click="$emit('salvar',form)">
                <i class="fa-solid fa-file-code mr-2"></i>
                Gerar XML
            </b-button>
        </div>
        <div class="col-12 mt-3">
            <h6>Lista de XML's Gerados</h6>
            <b-table head-variant="dark" hover :fields="table.fields" :items="itens">
                <template  #cell(actions)="data">
                    <div class="d-inline-flex">
                        <b-button variant="flat-primary" class="mr-2" @click="$emit('download', `${data.item.id}`)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                        <b-button variant="flat-danger"  v-if="!readonly && permissao.d " class="mr-2" @click="$emit('deletar', data.item.id)"><i class="fas fa-trash"></i></b-button>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import InputText from '@/components/inputs/InputText';
import InputSelect from '@/components/inputs/InputSelect';

import helpers from '@/common/utils/helpers';
import {FormMixin} from '@/common/mixins/FormMixin';
export default {
    name: 'Aneel1',
    mixins: [FormMixin],
    props: {
        itens : {            
            default: () => []
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components: {
        InputText,
        InputSelect
    },   
    data: () => ({
        form : {
            codigoInterno: "",
            versao: 0,
            avaliacaoInicial: null,
            ano : null
        },
        table : {
            items : [],
            fields : [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "versao", label:"Versão"},
                { key: "dataCriacao", label:"Data de emissão",
                    formatter: (value) => helpers.formatarDataBr(value)
                },
                { key: "actions", label:"Ações"},
            ]
        },
        options : {
            simnao : [
                {
                    value : 'S',
                    text : "Sim"
                },
                {
                    value : 'N',
                    text : "Não"
                }
            ]
        }
    })  , 
    watch: {
        itens: {
            handler: function(newValue) {
                this.form.versao = newValue.length ? newValue[newValue.length - 1].versao + 1 : 1;
            },
            deep: true,
            immediate: true
        }
    },
    
    computed :{
        readonly :function(){
            return this.$route.name != 'projeto-detalhamento' || !this.projetoEditavel
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdObrigacoesAneel');
        },
    }
}
</script>
<style lang="">
    
</style>